//import { Service, PAGEACTIVITY } from './../constantsSMB/actionType'
import { catchJSException } from './logService'
//import { getPDCforSC } from './apiService'
//import { Utils } from '../utilSMB/utils';
var vzdl = require('./vzdlData.json');


export const getVZDLInit = (visitID, pageName, category = "", addToCart = "", detail, eventValue, channel, errorMsg, userObj = {},txnObj = {}, eventNumber = "") => {
        
    let userinfo = "";    
    if (document.cookie && document.cookie.split(";").length > 0) {
        userinfo = document.cookie.split(";").find(val => val.indexOf('userinfo') !== -1)
        userinfo = userinfo && userinfo.split('userinfo=')[1]
    }

    var authStatus = "anonymous"
    var custRole = ""
    var custType = "NC"
    var event117 = ""
    var event116 = ""

    if (userinfo !== undefined && userinfo !== "") {
        authStatus = "Logged In"
        custRole = "accountHolder"
        custType = "EC"
    } else {
        authStatus = "anonymous"
        custType = "NC"
    }
    
    if (eventValue && eventValue === "scOpen,scAdd") {
        event117 = "event117"
    }
    if (eventValue && eventValue === "purchase") {
        event116 = "event116"
    }
    
    let events = "" 
    events = event117 + ((event116 && (event117)) ? "," + event116 : event116) + ((eventNumber && (event116 || event117)) ? "," + eventNumber : eventNumber)
    
    // Custom Event Dispatch
    if (addToCart && addToCart === true) {
        sendCustomEvent("AddtoCart");
    } else if (eventValue && eventValue === "prodView") {
        sendCustomEvent("ProdView")
    } else if (eventValue && eventValue === "scRemove") {
        sendCustomEvent("RemovefromCart")
    } else if (eventValue && eventValue === "cartView") {
        sendCustomEvent("CartView")
    } else if (eventValue && eventValue === "scCheckout") {
        sendCustomEvent("Checkout")
    } else if (eventValue && eventValue === "purchase") {
        sendCustomEvent("SubmitOrder")
    } else {
        sendCustomEvent("PageViewOmni")
    }
    try {
        vzdl.event.value = (eventValue === undefined || eventValue === "") ? "" + events : eventValue + (events ? "," + events : events),

            vzdl.error.code = (errorMsg === undefined || errorMsg === "") ? "" : errorMsg,

            vzdl.page.channel = (channel === undefined || channel === "") ? "" : channel,
            vzdl.page.channelSession = (visitID === undefined || visitID === "") ? "" : visitID,
            vzdl.page.detail = (detail === undefined || detail === "") ? "" : detail,
            vzdl.page.displayChannel = "VZF",
            vzdl.page.flow = "accessories",
            vzdl.page.name = (pageName !== undefined && pageName !== "") ? pageName : ""
            vzdl.page.sourceChannel = "VZF",
            vzdl.page.subFlow = "",
            vzdl.page.throttle = "",
            vzdl.page.contentFragments = "",
            vzdl.page.link = "",

            vzdl.user.existingServices = "",
            vzdl.user.account = "",
            vzdl.user.accountType = "",
            vzdl.user.customerRole = custRole,
            vzdl.user.customerType = custType,
            vzdl.user.authStatus = authStatus,
            vzdl.user.tenure = "",
            // vzdl.user.prospect = (userObj.prospect === undefined || userObj.prospect === "") ? "" : userObj.prospect,
            vzdl.user.session = "",
            vzdl.user.chatId = "",
            vzdl.user.zip = (userObj.zip === undefined || userObj.zip === "") ? "" : userObj.zip,
            vzdl.user.creditAppNum = "",
            vzdl.user.productsQualified = ""

        vzdl.env.businessUnit = "Wireline"
        if(userObj.prospect){
            getSHA256Val(userObj.prospect);
        }

        let newEvent = {
            "page": vzdl.page,
            "event": vzdl.event,
            "user": vzdl.user,
            "env": vzdl.env,
            "error": vzdl.error
        }
        window.vzdl = window.vzdl || {};
        window.vzdl = newEvent;
    }
    catch (ex) {
        catchJSException('vzdl', visitID, 'getVZDLInit', ex);
    }

}

var retrySendCustomEventCount = 0;
const sendCustomEvent = (evt) => {
    retrySendCustomEventCount = 0;
    if (window.dtm_doplugins) {
        if (document.createEvent && document.body.dispatchEvent) {
            var event = document.createEvent('Event');
            event.initEvent(evt, true, true);
            document.body.dispatchEvent(event);
        } else if (window.CustomEvent && document.body.dispatchEvent) {
            var ev = new CustomEvent(evt, {
                bubbles: true,
                cancelable: true
            });
            document.body.dispatchEvent(ev);
        }
    }
    else {
        setTimeout(() => { retrySendCustomEvent(evt); }, 500);
    }
}

const retrySendCustomEvent = (evt) => {
    retrySendCustomEventCount = retrySendCustomEventCount++;
    if (window.dtm_doplugins) {
        sendCustomEvent(evt);
    } else if (retrySendCustomEventCount < 5) {
        setTimeout(() => { retrySendCustomEvent(evt); }, 500);
    }
}

export const scDataDetails = {
    checkoutShipping: { pageName: "accessories| shipping information", detailPageName: "accessories| shipping information", events: "scCheckout" },
    checkoutBilling: { pageName: "accessories| billing information", detailPageName: "accessories| billing information", events: "scCheckout" },
    beginCheckout: { pageName: "accessories| begin checkout", detailPageName: "accessories| begin checkout", events: "event5" },
    viewCart: { pageName: "accessories| view cart", detailPageName: "accessories| view cart", events: "event5,prodView,scView,event22" },
    addToCart: { pageName: "accessories| pdp| add to cart", detailPageName: "accessories| pdp| add to cart", events: "event5,prodView,scAdd,scOpen" },
    orderReview: { pageName: "accessories| order review", detailPageName: "accessories| order review", events: "event46,event5" },
    orderReviewExpress: { pageName: "accessories| order review", detailPageName: "accessories| express| order review", events: "event5,event13,event14,event46,scCheckout" },
    orderConfirmation: { pageName: "accessories| order confirmation", detailPageName: "accessories| order confirmation", events: "event5,event40,event42,event43,event44,event55,purchase" },
    accessoriesHome: { pageName: "accessories home", detailPageName: "accessories| home", events: "event3" },
    accessoriesCategories: { pageName: "accessories| categories", detailPageName: "accessories| categories", events: "event3" },
    accessoriesPdpCategories: { pageName: "accessories| pdp", detailPageName: "accessories| pdp", events: "event5,event12,prodView" },
    featuredAccessories: { pageName: "accessories| pdp", detailPageName: "accessories| pdp", events: "event5,event12,prodView" },
    othersViewedAccessories: { pageName: "accessories| pdp", detailPageName: "accessories| pdp", events: "event5,event12,prodView" }
}

export const getSHA256Val = async (item) => {
    try {
      const shaKey = `TWoOwIsECMenIFOunDR97WMounTAIns8anD2A3DiaMOndYbUR15dCunderHN0rtHKELop`;
      let hashHex = "";
      const locusID= (item + shaKey) ;
      const msgUint8 = new TextEncoder().encode(locusID);                    
      const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);   
      const hashArray = Array.from(new Uint8Array(hashBuffer));               
      hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
      window.vzdl.user.prospect = hashHex; 
    } catch (error) {
      console.error("getSHA-256 failed", error);
      catchJSException('vzdl', visitID, 'getSHA256Val', ex);
    }
};
